export default function SessionUnavailable({ message, onRetry }) {
  return <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background p-6">
    <p role="alert">{message}</p>
    <button type="button" className="border px-4 py-2" onClick={onRetry}>Retry session</button>
  </div>;
}
